// extracted by mini-css-extract-plugin
export var callCard = "_m6-0";
export var callMessageButton = "_m6-1";
export var helpIcon = "_m6-3";
export var helpIconContainer = "_m6-4";
export var verticalDivider = "_m6-2";